// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2erGQ","footer":"ChangeClinic_footer__22jWv"};